const initialState = {
  loading: false,
  activities: [],
  error: null,
};

const activities = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ACTIVITIES_STARTED':
      return {
        ...state,
        loading: true,
      };
    case 'GET_ACTIVITIES_SUCCESS':
      return {
        ...state,
        loading: false,
        error: null,
        activities: action.payload,
      };
    case 'GET_ACTIVITIES_FAIL':
      return {
        ...state,
        loading: false,
        activities: [],
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default activities;
